module.exports = __webpack_public_path__ + "img/AUTO_DROIT_IMAGE_DESACTIVE.e9919114.svg";